module.exports = __webpack_public_path__ + "static/media/clinician-blood-thinner-types-preview@3x.815fd28e.png";